import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientsRoutingModule } from './clients-routing.module';
import { ClientsComponent } from './clients/clients.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ClientSummaryComponent } from './client-summary/client-summary.component';
import { ClientDetailComponent } from './client-detail/client-detail.component';
import { ClientFilesComponent } from './client-files/client-files.component';
import { ClientDocumentComponent } from './client-document/client-document.component';
import { ClientContactComponent } from './client-contact/client-contact.component';
import { ClientFinancialsComponent } from './client-financials/client-financials.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { ClientResolver } from 'src/app/shared/resolvers/clients.resolver';
import { ServiceResolver } from 'src/app/shared/resolvers/services.resolver';
import { ClientDetailsFormComponent } from './client-details-form/client-details-form.component';
import { CreateEditNoteComponent } from './create-edit-note/create-edit-note.component';
import { BankDetailsModalComponent } from './bank-details-modal/bank-details-modal.component';
import { ContactModalComponent } from './contact-modal/contact-modal.component';
import { UploadDocumentModalComponent } from './upload-document-modal/upload-document-modal.component';
import { CreateNewClientComponent } from './create-new-client/create-new-client.component';
import { ClientBankDetailsComponent } from './client-bank-details/client-bank-details.component';
import { ClientContractsComponent } from './client-contracts/client-contracts.component';
import { ClientPartnersComponent } from './client-partners/client-partners.component';
import { PartnersModalComponent } from './partners-modal/partners-modal.component';
import { ContractFormComponent } from './contract-form/contract-form.component';

@NgModule({
  declarations: [
    ClientsComponent,
    ClientSummaryComponent,
    ClientDetailComponent,
    ClientFilesComponent,
    ClientDocumentComponent,
    ClientContactComponent,
    ClientFinancialsComponent,
    ClientDetailsFormComponent,
    CreateEditNoteComponent,
    BankDetailsModalComponent,
    ContactModalComponent,
    UploadDocumentModalComponent,
    CreateNewClientComponent,
    ClientBankDetailsComponent,
    ClientContractsComponent,
    ClientPartnersComponent,
    PartnersModalComponent,
    ContractFormComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    FormsModule,
    NgbModule,
    ClientsRoutingModule,
    NgxDropzoneModule,

  ],
  providers: [
    ClientResolver,
    ServiceResolver
  ]
})
export class ClientsModule { }
